<template>

  <van-action-sheet v-model:show="show" title="服务评价" @close="btnClick">
    <div class="content">
      <template v-if="tips == 1">
        <div class="mb-30">
          <p class="tit">请对技术人员响应速度或回复及时性评分？</p>
          <div class="li mt-20" data-flex="cross:center">
            <p v-for="(item, index) in 10" :class="{ on: formData.score1 - 1 == index }"
              @click="scoreNum('score1', index)">
              {{ item }}</p>
          </div>
        </div>
        <div class="mb-30">
          <p class="tit">请对技术人员上门的服务态度评分？</p>
          <div class="li mt-20" data-flex="cross:center">
            <p v-for="(item, index) in 10" :class="{ on: formData.score2 - 1 == index }"
              @click="scoreNum('score2', index)">
              {{ item }}</p>
          </div>
        </div>
        <div class="mb-30">
          <p class="tit">请对技术人员上门的服务专业性评分？</p>
          <div class="li mt-20" data-flex="cross:center">
            <p v-for="(item, index) in 10" :class="{ on: formData.score3 - 1 == index }"
              @click="scoreNum('score3', index)">
              {{ item }}</p>
          </div>
        </div>
        <div class="mb-30">
          <p class="tit mt-40">本次上门服务为您提供了哪些服务？</p>
          <div>
            <van-checkbox-group v-model="formData.provideService" class="checked">
              <van-checkbox name="故障检修">故障检修</van-checkbox>
              <van-checkbox name="全面巡检">全面巡检</van-checkbox>
              <van-checkbox name="使用答疑">使用答疑</van-checkbox>
              <van-checkbox name="产品培训">产品培训</van-checkbox>
              <van-checkbox name="产品方案介绍">产品方案介绍</van-checkbox>
              <van-checkbox name="服务方案介绍">服务方案介绍</van-checkbox>
            </van-checkbox-group>
          </div>
        </div>
      </template>
      <div class="mb-30">
        <p class="tit">请为本次服务进行综合评分*</p>
        <div class="li mt-20" data-flex="cross:center">
          <p v-for="(item, index) in 10" :class="{ on: formData.score - 1 == index }" @click="scoreNum('score', index)">
            {{ item }}</p>
        </div>
      </div>
      <div class="mb-30">
        <p class="tit mt-40">对奥威亚产品功能、应用、服务等方面有什么需求或建议?</p>
        <div class="inp mt-20" data-flex="cross:center">
          <van-field class="f-fs12" v-model="formData.propose" type="textarea" placeholder="请输入您的需求或建议" />
        </div>
      </div>
      <div class="btn">
        <van-button type="primary" @click="submit">立即提交</van-button>
      </div>
    </div>
  </van-action-sheet>

</template>

<script>
import customEvents from '@/config/custom_events'
import mix1 from '@/mixins/page'
import bus from '@/libs/bus'
import { getRandomString } from '@/utils/string'
import { getWindowHeight } from '@/utils/common'
import { ActionSheet, Button, Field, Checkbox, CheckboxGroup, Dialog, Toast } from 'vant'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'

const defaultBtnText = '我知道了'
const defaultZIndex = 8888

export default {
  mixins: [mix1],
  name: 'evaluate',
  components: {
    [Dialog.name]: Dialog,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  data() {
    return {
      checked: ['a'],
      windowHeight: 667,
      show: false,
      tips: '',
      btnCallback: null,
      zIndex: defaultZIndex,
      formData: {
        id: '',
        score: 1,
        score1: 1,
        score2: 1,
        score3: 1,
        provideService: [],
        propose: '',
      },
    }
  },
  computed: {
    wrapperStyle() {
      return {
        height: `${this.windowHeight}px`,
        zIndex: this.zIndex
      }
    }
  },
  methods: {
    btnClick() {
      this.show = false
      document.getElementById('app').dataset.dialogId = ''

      if (!this.btnCallback) {
        return
      }

      this.$nextTick(() => this.btnCallback())
    },
    scoreNum(name, index) {
      this.formData[name] = index + 1
    },
    submit() {
      console.log('formData', this.formData)
      let formData = this.formData
      let {
        id,
        score,
        score1,
        score2,
        score3,
        provideService,
        propose } = formData
      let data = {
        id,
        score,
        score1,
        score2,
        score3,
        provideService: JSON.stringify(provideService),
        propose
      }
      Dialog.confirm({
        // title: '删除',
        message:
          '确定提交？',
      })
        .then(async () => {
          const promise = this.apiPost('orders.appraise', data)

          let apiResult = null

          uiShowLoading()

          try {
            apiResult = await promise
          } catch (ex) {
            apiResult = null
          }

          uiHideLoading()
          if (this.isEmpty(apiResult) || apiResult.errno != 0) {
            Toast(apiResult.error);
            return
          }

          Toast('操作成功');
          this.show = false

          let obj = apiResult.obj
          if(obj.code == 1){
              location.href = obj.url
          } else {
              location.reload()
          }
          // location.reload()
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  created() {
    this.windowHeight = getWindowHeight()
  },
  mounted() {
    bus.$on(customEvents['evaluate.show'], (message = {}) => {

      // const el = document.getElementById('app')
      // const id = el.dataset.dialogId

      // if (id) {
      //   return
      // }

      const { tips, btnCallback, zIndex, orderId } = message

      if (!tips) {
        return
      }
      if (!orderId) {
        return
      }
      console.log('message', message)
      this.show = true
      this.tips = tips
      this.btnCallback = btnCallback || null
      this.zIndex = zIndex || defaultZIndex
      // el.dataset.dialogId = getRandomString(8, 2)
      this.formData.id = orderId
    })
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 30px;
  box-sizing: border-box;

  .van-checkbox__icon--checked .van-icon {
    background-color: #E8C767;
    border-color: #E8C767;
  }

  .tit {
    color: #B5B5B5;
  }

  .checked {
    width: 100%;
    display: inline-block;

    >div {
      float: left;
      width: 33.33%;
      margin: 20px 0px;
    }
  }

  .li {
    p {
      width: 54px;
      height: 54px;
      border: solid 1px #B5B5B5;
      border-radius: 4px;
      text-align: center;
      line-height: 54px;
      color: #B5B5B5;
      margin: 0 6px;
    }

    .on {
      background: #E8C767;
      border: solid 1px #E8C767;
      color: #fff;
    }
  }

  .inp {
    border: solid 1px #B9B9B9;
    width: 100%;
    margin: 0 auto;
    border-radius: 10px;
    margin-bottom: 40px;

    .van-cell {
      padding: 10px;
    }

    .van-cell::after {
      border: none;
    }
  }

  .btn {
    width: 100%;
    text-align: center;
    margin-top: 50px;
    margin-bottom: 30px;

    button {
      background: #D65E5E;
      color: #fff;
      border-radius: 100px;
      border-color: #D65E5E;
      width: 225px;
      height: 68px;
      margin: 0 auto;
    }

  }
}
</style>